import { render, staticRenderFns } from "./StepBlock.vue?vue&type=template&id=1076886d&"
import script from "./StepBlock.vue?vue&type=script&lang=js&"
export * from "./StepBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports